module.exports = __webpack_public_path__ + "static/img-10-223241e55c2fb49b4d440eb40a30a8ce.jpeg";